import { EMPTY_HEART, FULL_HEART } from "../../../tiles";
import { GlyphBar } from "../../../ui/dataInfo/GlyphBar";
import { ComponentF, createElement } from "../../../ui/ui";
import { Actor } from "../../actors/Actor";
import Colors from "../../Colors";

export const ActorDetailDisplay: ComponentF<{ actor: Actor | null }> = (
  C,
  { actor }
) => {
  if (actor === null) {
    return;
  }

  let y = C.bounds.y;

  if (actor.aiProps.words) {
    C.display.drawText(
      C.bounds.x,
      C.bounds.y + 1,
      actor.aiProps.words.join(" "),
      C.bounds.w - 1
    );
  } else {
    C.display.drawText(
      C.bounds.x,
      C.bounds.y + 1,
      actor.breed.name,
      C.bounds.w - 1
    );
  }

  return [
    createElement(
      GlyphBar,
      { x: 0, y: 0, w: 10, h: 1 },
      {
        full: FULL_HEART,
        empty: EMPTY_HEART,
        current: actor.health.current,
        max: actor.health.max,
        fullColor: Colors.PINK_4,
      }
    ),
  ];
};
